import { AdminLot } from '../model/adminLot';
export class AdminLotBuilder {
    static buildAdminLot(data) {
        const adminLot = new AdminLot();
        adminLot.id = data.id;
        adminLot.is_active = data.is_active;
        adminLot.name = data.name;
        adminLot.name_short = data.name_short;
        adminLot.mark = data.mark;
        adminLot.company_name = data.company_name;
        adminLot.address = data.address;
        adminLot.city = data.city;
        adminLot.state = data.state;
        adminLot.zip = data.zip;
        adminLot.phone = data.phone;
        adminLot.email = data.email;
        adminLot.web = data.web;
        adminLot.nif = data.nif;
        adminLot.thanks = data.thanks;
        adminLot.products_csv = data.products_csv;
        adminLot.terminals_csv = data.terminals_csv;
        adminLot.plate_reader_cams_csv = data.plate_reader_cams_csv;
        adminLot.plate_reader_server = data.plate_reader_server;
        adminLot.capacity = data.capacity;
        adminLot.ask_for_passengers = data.ask_for_passengers;
        adminLot.ship = data.ship;
        adminLot.text = data.text;
        adminLot.multiterminal_shuttles = data.multiterminal_shuttles;
        return adminLot;
    }
}
//# sourceMappingURL=adminLot-builder.js.map